<template>
    <modal-content-container
        id="faq"
        title="Frequently Asked Questions"
        description=""
    >
        <div
            v-for="(section, i) in content"
            :key="i"
            class="section-container"
        >
            <div class="section-heading">
                {{ section.title }}
            </div>
            <div
                v-for="({question, answer}, j) in section.questions"
                :key="j"
                class="question-container"
            >
                <div class="question">
                    {{ question }}
                </div>
                <div
                    v-for="(line, k) in answer"
                    :key="k"
                    :class="'answer ' + line.type"
                >
                    <div
                        v-if="line.type !== 'link' && line.type !== 'download'"
                    >
                        {{ resolveContent(line) }}
                    </div>
                    <a
                        v-if="line.type === 'link'"
                        :href="line.href"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {{ line.content }}
                    </a>
                    <div
                        v-if="line.type === 'download'"
                        @click="downloadContent(line.filename)"
                    >
                        {{ line.content }}
                    </div>
                </div>
            </div>
        </div>
    </modal-content-container>
</template>

<script>
import { saveAs } from 'file-saver';
import ModalContentContainer from '@/views/tabs/ModalContentContainer.vue';

export default {
    components: {
        ModalContentContainer
    },
    props: {
        content: {
            type: Array,
            required: true
        }
    },
    methods: {
        resolveContent({ type, content }) {
            if (type === 'text') {
                return content;
            }
            if (type === 'bullet') {
                return `• ${content}`;
            }
            return '';
        },
        downloadContent(filename) {
            saveAs(`${process.env.BASE_URL}data/indicators/help/${filename}`, filename);
        }
    }
};
</script>

<style lang="postcss" scoped>
.section-container {
    @apply mb-8;
}

.section-heading {
    @apply text-lg font-normal text-primary-4;
}

.question-container {
    @apply my-4;
    max-width: 70%;
}

@screen mobile {
    #faq {
        @apply px-4;
        overflow-x: hidden;
    }
    .question-container {
        max-width: 100%;
    }
}

.question {
    @apply font-normal mb-2;
}

.answer {
    @apply w-full text-sm font-normal text-neutral-text normal-case;
}

.text {
    @apply mt-2;
}

.bullet {
    @apply pl-4;
}

.link {
    text-decoration: underline;
    word-wrap: break-word;
}

.download {
    text-decoration: underline;
    cursor: pointer;
}
</style>
